import React from "react";

export default function SongkranFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-son31{fill:#fbdf07}.cls-son32{fill:#f45611}.cls-son34{fill:#bb1def}.cls-son35{fill:#5aaddb}.cls-son36{fill:#f94892}.cls-son37{fill:#f980b7}"
            }
          </style>
        </defs>
        <path
          d="M1658.38 1852.6H479.17c-105.71 0-191.7-86-191.7-191.7V481.69c0-105.71 86-191.7 191.7-191.7h1179.21c105.71 0 191.7 86 191.7 191.7V1660.9c0 105.71-86 191.7-191.7 191.7ZM479.17 323.43c-87.27 0-158.26 71-158.26 158.26V1660.9c0 87.27 71 158.26 158.26 158.26h1179.21c87.27 0 158.26-71 158.26-158.26V481.69c0-87.27-71-158.26-158.26-158.26H479.17Z"
          className="cls-son31"
        />
        <path
          d="M399.92 1126.5c7.1 13.05 77.62-40.71 189.59-29.49 87.48 8.77 133.82 50.55 144.07 37.08 12.8-16.82-39.96-107.56-120.45-125.97-111.8-25.57-222.74 100.87-213.21 118.38Z"
          className="cls-son31"
        />
        <path
          d="M329.39 1833.61c-25.48-45.15-119.6-224.32-66.51-445.61 31.82-132.62 102.51-222.02 143-266.04-27.05 47.48-95.13 181.45-79.81 362.48 15.39 181.77 105.71 302.72 140.39 344.86-45.69 1.44-91.38 2.88-137.07 4.31Z"
          className="cls-son35"
        />
        <path
          d="M404.57 1129.04c-14.77 1.55-10.44-87.03-83.14-172.92-56.8-67.11-117.48-81.61-112.19-97.69 6.61-20.08 111.27-28.03 172.05 27.86 84.42 77.63 43.11 240.68 23.28 242.76Z"
          className="cls-son34"
        />
        <path
          d="M403.05 1130.03c-7.66 12.73-75.78-44.05-188.13-37.71-87.78 4.96-135.89 44.68-145.54 30.78-12.06-17.36 44.6-105.72 125.81-120.61 112.81-20.68 218.14 110.46 207.86 127.54Z"
          className="cls-son32"
        />
        <path
          d="M399.97 1128.31c-6.15 13.52 79.24 37.48 137.68 133.64 45.66 75.14 40.19 137.28 57.12 137.36 21.14.1 61.84-96.66 28.09-172.01-46.88-104.67-214.63-117.14-222.88-98.99Z"
          className="cls-son36"
        />
        <path
          d="M429.23 1478.85c3.54 6.51 38.75-20.32 94.64-14.72 43.67 4.38 66.8 25.23 71.92 18.51 6.39-8.4-19.95-53.69-60.13-62.88-55.81-12.76-111.19 50.35-106.43 59.1Z"
          className="cls-son34"
        />
        <path
          d="M394.02 1831.83c-12.72-22.54-59.7-111.98-33.2-222.45 15.88-66.2 51.17-110.83 71.38-132.8-13.5 23.7-47.49 90.58-39.84 180.95 7.68 90.74 52.77 151.12 70.08 172.15-22.81.72-45.62 1.44-68.42 2.15Z"
          className="cls-son32"
        />
        <path
          d="M431.55 1480.12c-7.37.77-5.21-43.44-41.5-86.32-28.35-33.5-58.64-40.74-56-48.77 3.3-10.02 55.55-13.99 85.88 13.91 42.14 38.75 21.52 120.15 11.62 121.18Z"
          className="cls-son31"
        />
        <path
          d="M430.79 1480.61c-3.82 6.35-37.83-21.99-93.91-18.82-43.82 2.47-67.83 22.31-72.65 15.36-6.02-8.67 22.26-52.78 62.8-60.21 56.31-10.33 108.89 55.14 103.76 63.67Z"
          className="cls-son36"
        />
        <path
          d="M429.25 1479.75c-3.07 6.75 39.55 18.71 68.73 66.71 22.79 37.51 20.06 68.53 28.51 68.57 10.55.05 30.87-48.25 14.02-85.87-23.4-52.25-107.14-58.48-111.26-49.42Z"
          className="cls-son35"
        />
        <path
          d="M1691.95 221.02s47.89-26.04 72.46 48.54c24.58 74.58-.48 132.01-51.2 71.63-50.73-60.38-47.12-116.28-21.26-120.17Z"
          className="cls-son32"
        />
        <path
          d="M1888.51 268.27s39.16 37.92-24.68 83.66c-63.84 45.74-126.12 38.98-83.66-27.46 42.47-66.45 96.89-79.71 108.33-56.19Z"
          className="cls-son32"
        />
        <path
          d="M1904.32 454.74s-18.91 51.12-86.5 11.15c-67.59-39.98-86.53-99.7-8.6-87.63 77.93 12.07 112.01 56.53 95.1 76.48Z"
          className="cls-son32"
        />
        <path
          d="M1704.82 536.79s-52.99-12.77-21.25-84.59c31.75-71.83 88.83-97.65 86.01-18.84-2.82 78.81-42.96 117.88-64.76 103.44Z"
          className="cls-son32"
        />
        <path
          d="M1586.54 380.7s-5.5-54.23 72.79-48.05 121.55 51.49 46.25 74.92-125.45-1.51-119.04-26.87Z"
          className="cls-son32"
        />
        <path
          d="M1796.09 381.05c-4.24-1.34-8.9-2.42-13.98-3.21-.84-.14-1.64-.24-2.43-.32-.79-.11-1.55-.18-2.28-.23-1.02-.09-1.98-.14-2.91-.15h-.08s.05 0 .06-.01c.94-.12 1.93-.29 2.94-.5.09-.02.18-.03.26-.06 7.59-1.64 16.77-5.84 26.05-12.49 28.93-20.71 11.19-37.9 11.19-37.9-4.65-9.57-24.97-5.72-42.98 16.9-1.1 1.35-2.16 2.78-3.24 4.29-.96 1.37-1.93 2.78-2.87 4.27-1.02 1.6-1.9 3.12-2.66 4.56-.2.38-.4.76-.58 1.13.06-.43.12-.85.15-1.29.84-7.82-.4-18.11-4.06-29.28-11.13-33.79-32.84-21.99-32.84-21.99-11.39 1.72-13.26 25.73 7.8 52.2.59.75 1.2 1.51 1.84 2.25.85 1.03 1.7 1.98 2.52 2.86-1.54-.76-3.21-1.48-5-2.14-6.1-2.27-13.57-3.92-21.95-4.58-35.47-2.8-32.99 21.78-32.99 21.78-2.91 11.48 19.83 22.78 53.95 12.17.47-.15.93-.29 1.37-.44.03 0 .05-.02.06-.02.94-.32 1.84-.64 2.69-.97 1.49-.58 2.86-1.17 4.08-1.78.41-.21.79-.41 1.16-.61-.18.14-.38.27-.56.44-1.26.96-2.54 2.08-3.8 3.36-1.98 1.95-3.92 4.24-5.83 6.86-3.27 4.47-6.37 9.82-9.08 15.95-14.39 32.55 9.63 38.34 9.63 38.34 9.38 6.2 26.23-9.41 29.02-41.54.17-1.73.27-3.51.33-5.34.06-1.92.05-3.71-.03-5.35-.11-2.27-.36-4.27-.73-6.05.68 1.72 1.66 3.51 2.89 5.35.82 1.2 1.75 2.43 2.78 3.67 4.62 5.55 11.47 11.32 20.01 16.38 30.63 18.11 39.19-5.05 39.19-5.05 6.57-7.76-3.82-23.63-29.11-31.45Zm-50.57 1.64c.05.08.09.15.12.24-.37.15-.73.33-1.11.53.35-.26.68-.52.99-.78Z"
          style={{
            fill: "#ff7545",
          }}
        />
        <circle cx={1755.29} cy={376.84} r={22.12} className="cls-son32" />
        <path
          d="M1902.6 491.91s28.75 19.99-6.99 55.59c-35.74 35.61-75.93 37.77-55.88-8.76s53.18-60.56 62.87-46.84Z"
          className="cls-son36"
        />
        <path
          d="M1932.12 618.39s-10.49 33.41-55.14 9.94c-44.66-23.47-58.73-61.18-8.34-55.95 50.39 5.23 73.69 32.66 63.48 46.01Z"
          className="cls-son36"
        />
        <path
          d="M1829.61 681.2s-34.8 3.88-31.33-46.45c3.47-50.33 32.31-78.41 47.83-30.19 15.53 48.22-.18 80.6-16.5 76.64Z"
          className="cls-son36"
        />
        <path
          d="M1725.01 590.3s-7.94-34.11 42.45-36.58c50.39-2.47 81.67 22.86 35.61 43.95-46.06 21.09-80.06 9.3-78.05-7.38Z"
          className="cls-son36"
        />
        <path
          d="M1780.54 477.4s29.55-18.78 48.57 27.95c19.01 46.73 5.46 84.63-29.69 48.15s-35.28-72.47-18.88-76.09Z"
          className="cls-son36"
        />
        <path
          d="M1840.73 597.82c-.45-2.82-1.18-5.81-2.19-8.95-.16-.52-.33-1.01-.52-1.49-.17-.48-.34-.94-.53-1.38-.24-.61-.49-1.17-.75-1.71l-.02-.04s.01.03.03.03c.34.51.72 1.03 1.13 1.54.03.05.07.1.11.13 3.13 3.88 8.19 7.95 14.68 11.36 20.23 10.64 24.99-4.5 24.99-4.5 4.15-5.43-3.91-15.99-22.09-19.81-1.09-.24-2.22-.44-3.4-.62a62.32 62.32 0 0 0-3.28-.42c-1.21-.12-2.34-.19-3.39-.21h-.81c.26-.09.52-.18.79-.29 4.73-1.77 10.29-5.45 15.64-10.77 16.19-16.13 3.16-25.19 3.16-25.19-4.27-6.05-18.6-.2-27.72 19.52-.26.56-.52 1.12-.76 1.71-.35.79-.64 1.55-.91 2.27 0-1.1-.08-2.27-.21-3.49-.46-4.15-1.66-8.92-3.7-13.92-8.61-21.17-22.01-12.66-22.01-12.66-7.43 1.64-7.37 17.95 8.56 34.48.22.23.43.45.65.66 0 .02.02.02.03.03.46.45.9.87 1.33 1.27.76.69 1.5 1.3 2.2 1.83.24.17.46.34.68.49-.13-.07-.27-.14-.42-.2-.91-.45-1.93-.86-3.03-1.21-1.69-.57-3.57-1.03-5.62-1.37-3.51-.59-7.48-.83-11.78-.62-22.83 1.12-19.24 16.58-19.24 16.58-.86 7.18 12.97 12.35 32.21 4.69 1.04-.4 2.1-.86 3.16-1.35 1.12-.52 2.14-1.04 3.06-1.56a25.4 25.4 0 0 0 3.27-2.16c-.79.89-1.54 1.96-2.24 3.2-.45.82-.89 1.71-1.3 2.65-1.85 4.25-3.19 9.84-3.64 16.21-1.57 22.81 14.19 21.05 14.19 21.05 6.35 1.54 12.47-9 9.67-25.78Zm-15.52-28.56s-.06.1-.1.14c-.19-.17-.4-.32-.63-.48.25.13.49.24.73.34Z"
          className="cls-son37"
        />
        <circle cx={1831.39} cy={573.18} r={14.21} className="cls-son36" />
        <path
          d="M1646.24 315.06s-18.57 21.13-43.74-10.63c-25.17-31.76-23.25-64.04 12.07-43.81 35.31 20.23 43.51 47.95 31.67 54.44Z"
          className="cls-son36"
        />
        <path
          d="M1542.61 327.13s-25.72-11.41-2.92-44.92c22.79-33.51 54.17-41.32 45.41-1.57-8.76 39.74-32.76 55.85-42.49 46.49Z"
          className="cls-son36"
        />
        <path
          d="M1501.79 239.6s.07-28.13 39.93-20.79c39.86 7.35 59.65 32.91 19.75 40.92-39.9 8.01-64.32-7.47-59.68-20.14Z"
          className="cls-son36"
        />
        <path
          d="M1583.85 164.37s27.94-3.24 25.34 37.2c-2.61 40.44-25.67 63.11-38.32 24.43-12.65-38.68-.15-64.75 12.98-61.63Z"
          className="cls-son36"
        />
        <path
          d="M1668.91 218.95s12.31 25.3-26.72 36.23c-39.03 10.93-68.05-3.33-35.73-28.07 32.31-24.74 61.05-21.58 62.45-8.15Z"
          className="cls-son36"
        />
        <path
          d="M1567.33 256.05c2.29-.11 4.74-.41 7.34-.93.43-.08.84-.17 1.24-.28.4-.09.78-.19 1.15-.3.51-.14.98-.29 1.43-.44h.04-.03c-.44.23-.88.48-1.33.77-.04.02-.08.05-.11.08-3.38 2.15-7.09 5.81-10.4 10.68-10.33 15.18 1.32 20.35 1.32 20.35 3.96 3.81 13.12-1.67 17.82-15.83.29-.85.55-1.73.81-2.65.22-.83.44-1.69.63-2.58.21-.95.37-1.85.48-2.68.03-.22.06-.44.08-.65.05.22.09.43.16.65.98 3.94 3.41 8.71 7.17 13.46 11.4 14.39 19.82 4.81 19.82 4.81 5.21-2.86 1.85-14.83-13.06-23.9-.42-.26-.85-.52-1.29-.76-.6-.35-1.18-.65-1.73-.94.88.1 1.82.14 2.81.15 3.36.01 7.27-.51 11.45-1.69 17.68-4.95 12.11-16.42 12.11-16.42-.63-6.08-13.66-7.51-28.3 3.7-.2.16-.4.3-.58.46-.01 0-.02.02-.03.02a29.615 29.615 0 0 0-2.79 2.54c-.16.18-.31.34-.45.5.06-.1.14-.2.19-.31.44-.69.86-1.46 1.24-2.3.61-1.29 1.15-2.75 1.6-4.36.79-2.75 1.34-5.89 1.56-9.34 1.18-18.33-11.48-16.86-11.48-16.86-5.65-1.34-11.04 9.23-6.67 25.28.23.87.49 1.75.79 2.65.31.94.64 1.81.97 2.59.45 1.08.94 2.01 1.43 2.8-.64-.71-1.43-1.41-2.35-2.08-.61-.44-1.28-.87-2-1.28-3.23-1.87-7.57-3.44-12.61-4.38-18.06-3.33-18.09 9.42-18.09 9.42-1.8 4.93 6.05 10.77 19.7 10.06Zm24.21-9.79s-.07-.06-.1-.1c.15-.14.29-.29.44-.46-.12.19-.24.37-.34.55Z"
          className="cls-son37"
        />
        <circle cx={1587.84} cy={250.83} r={11.41} className="cls-son36" />
        <path
          d="M1838.46 1506.61c-18.98-17.55-37.91-30.99-54.41-41.13l-11.69 9.6c-33.06 27.16-36.67 71.26-8.05 98.48 28.61 27.22 78.61 27.27 111.67.1l11.69-9.6c-11.33-16.94-27.22-37.1-49.21-57.45Z"
          className="cls-son32"
        />
        <path
          d="M1772.28 1471.47c-1.19-2.02-1.25-4.57.08-6.88 2.21-3.82 7.41-5.57 11.61-3.89 2.78 1.11 68.49 27.96 108.81 103.18 1.97 3.67.06 8.26-4.26 10.25-4.32 2-9.45.6-11.39-3.03-37.89-70.68-100.53-96.3-101.16-96.55-1.66-.66-2.92-1.76-3.69-3.08ZM1971.04 1632.74c-18.98-17.55-37.91-30.99-54.41-41.13l-11.69 9.6c-33.06 27.16-36.67 71.26-8.05 98.48s78.61 27.27 111.67.1l11.69-9.6c-11.33-16.94-27.22-37.1-49.21-57.45Z"
          className="cls-son32"
        />
        <path
          d="M1904.88 1597.6c-1.19-2.03-1.25-4.58.09-6.89 2.21-3.82 7.4-5.56 11.6-3.88 2.78 1.11 68.49 27.96 108.81 103.18 1.97 3.67.06 8.26-4.26 10.25-4.32 2-9.43.63-11.39-3.03-37.73-70.38-100.54-96.31-101.17-96.56-1.65-.66-2.9-1.76-3.67-3.07ZM1839.35 1586.85a6.197 6.197 0 0 1-.77-4.23c.68-3.97 4.82-6.95 9.3-6.66 15.44 1 46.13 12.38 51.77 48.34.61 3.92-2.54 7.76-7.06 8.58-4.51.82-8.67-1.7-9.28-5.61-5.33-34.01-36.51-36.75-37.84-36.85-2.75-.21-4.97-1.6-6.13-3.56Z"
          className="cls-son32"
        />
        <path
          d="M1655.85 1712.13c-14.6 5.24-26.89 11.56-36.72 17.5l2.4 8.74c6.8 24.71 30.49 38.5 52.93 30.8s35.11-33.96 28.31-58.67l-2.4-8.74c-12.32 1.38-27.59 4.29-44.52 10.37Z"
          className="cls-son34"
        />
        <path
          d="M1619.5 1737.43c-1.43.08-2.87-.57-3.82-1.9-1.58-2.19-1.23-5.4.77-7.15 1.32-1.16 32.93-28.45 85.11-29.35 2.54-.04 4.62 2.2 4.64 5.01.02 2.81-2.05 5.13-4.57 5.17-49.03.84-79.18 26.85-79.48 27.12-.79.69-1.72 1.06-2.65 1.11ZM1759.79 1676.47c-14.6 5.24-26.89 11.56-36.72 17.5l2.4 8.74c6.8 24.71 30.49 38.5 52.93 30.8 22.43-7.7 35.11-33.96 28.31-58.67l-2.4-8.74c-12.32 1.38-27.59 4.29-44.51 10.37Z"
          className="cls-son34"
        />
        <path
          d="M1723.44 1701.77c-1.43.08-2.87-.58-3.82-1.91-1.57-2.19-1.23-5.39.77-7.14 1.32-1.16 32.93-28.45 85.11-29.35 2.54-.04 4.62 2.2 4.64 5.01.02 2.81-2.04 5.13-4.57 5.17-48.83.84-79.18 26.86-79.49 27.12-.79.69-1.71 1.05-2.64 1.1ZM1700.86 1733.31c-.87.05-1.77-.19-2.56-.74-2.05-1.43-2.66-4.41-1.36-6.69 4.46-7.85 18.58-20.91 40.08-14.17 2.34.73 3.69 3.43 3.01 6.02-.68 2.59-3.14 4.1-5.48 3.36-20.33-6.37-29.75 9.28-30.14 9.94-.81 1.39-2.15 2.18-3.54 2.26Z"
          className="cls-son34"
        />
        {children}
      </g>
    </svg>
  );
}
